<div class="connected-users" *ngIf="sidenavOpen; else collapsedView">
    <div class="user" *ngFor="let user of connectedUsers; trackBy: trackByFn" [title]="user.name">
        <app-user-avatar class="avatar" [avatarUrl]="user.avatar" [firstName]="user.firstName"
            [lastName]="user.lastName" [showStatus]="false" [loading]="loadingAvatar" [showUploadProgress]="true" [size]="40">
        </app-user-avatar>
    </div>
</div>

<ng-template #collapsedView>
    <div class="collapsed-user" *ngIf="connectedUsers.length">
        <img [src]="defaultAvatar" alt="Users" [title]="getUserNames()">
        <span *ngIf="connectedUsers.length > 0" class="badge">{{ connectedUsers.length }}</span>
    </div>
</ng-template>